import { Tab, Tabs, TabsList } from "@merge-api/merge-javascript-shared";
import { useHistory, useLocation } from "react-router-dom";
import {
  getBlueprintsPath,
  getConductorTabPath,
  getIntegrationChangelogPath,
  getPublishRequestsPath,
  getReportTemplatesPath,
  getScrapersPath,
  getTestSuitesTablePath,
} from "../../../router/RouterUtils";
import { IntegrationChatWidget } from "../../blueprint-editor/chat-bpe/components/IntegrationChatWidget";

const IntegrationTabs = ({ integrationID }: { integrationID: string }) => {
  const location = useLocation();
  const history = useHistory();

  const baseTabData = [
    {
      label: "Blueprints",
      value: "blueprints",
      destination: () => getBlueprintsPath(integrationID),
      baseDestination: () => `/integrations/${integrationID}/blueprints`,
    },
    {
      label: "Conductor",
      value: "conductor",
      destination: () => getConductorTabPath(integrationID),
      baseDestination: () => `/integrations/${integrationID}/conductor`,
    },
    {
      label: "Report Templates",
      value: "reportTemplates",
      destination: () => getReportTemplatesPath(integrationID),
      baseDestination: () => `/integrations/${integrationID}/report-templates`,
    },
    {
      label: "Scrapers",
      value: "scrapers",
      destination: () => getScrapersPath(integrationID),
      baseDestination: () => `/integrations/${integrationID}/scrapers`,
    },
    {
      label: "Mapping tests",
      value: "mappingTests",
      destination: () => getTestSuitesTablePath(integrationID),
      baseDestination: () => `/integrations/${integrationID}/test-suites`,
    },
    {
      label: "Publish requests",
      value: "publishRequests",
      destination: () => getPublishRequestsPath(integrationID),
      baseDestination: () => `/integrations/${integrationID}/publish-requests`,
    },
    {
      label: "Changelog",
      value: "changelog",
      destination: () => getIntegrationChangelogPath(integrationID),
      baseDestination: () => `/integrations/${integrationID}/changelog`,
    },
  ];

  const tabData = baseTabData;

  const findCurrentTab = () => {
    // Use baseDestination for robust tab matching
    const matchingTab = tabData
      .slice()
      .sort((a, b) => b.baseDestination().length - a.baseDestination().length)
      .find((tab) => {
        const base = tab.baseDestination();
        return location.pathname === base || location.pathname.startsWith(base + "/");
      });
    return matchingTab ? matchingTab.value : "blueprints";
  };

  const onTabChange = (_: any, newValue: string | number | null) => {
    if (typeof newValue === "string") {
      const selectedTab = tabData.find((tab) => tab.value === newValue);
      if (selectedTab && selectedTab.destination) {
        history.push(selectedTab.destination());
      }
    }
  };

  return (
    <div className="w-full mt-4 mb-6">
      <div className="border-b border-gray-10 flex-wrap">
        <Tabs value={findCurrentTab()} variant="underline" onChange={onTabChange}>
          <TabsList className="border-b-0">
            {tabData.map((tab) => (
              <Tab className="whitespace-nowrap" key={tab.value} value={tab.value}>
                {tab.label}
              </Tab>
            ))}
          </TabsList>
        </Tabs>
        <IntegrationChatWidget integration_id={integrationID} />
      </div>
    </div>
  );
};

export default IntegrationTabs;
